import { render, staticRenderFns } from "./TransactionCapturedBadge.vue?vue&type=template&id=39fc202d&scoped=true&"
import script from "./TransactionCapturedBadge.vue?vue&type=script&lang=js&"
export * from "./TransactionCapturedBadge.vue?vue&type=script&lang=js&"
import style0 from "./TransactionCapturedBadge.vue?vue&type=style&index=0&id=39fc202d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fc202d",
  null
  
)

export default component.exports